import module from 'module';
import templateUrl from './help.template.html';
import './help.style.less';


module.component('help', {
  templateUrl,
});